export const MAIN_SIDEBAR_OWNER = [
  // {
  //   name: 'mainsidebar.label.database',
  //   path: '/database',
  //   icon: null,
  // },
  // {
  //   name: 'mainsidebar.label.helpDesk',
  //   path: '/help-desk',
  //   icon: null,
  //   children: [
  //     {
  //       name: 'mainsidebar.label.corporateRequests',
  //       path: '/corporates/pending',
  //       icon: null,
  //     },
  //   ],
  // },
  // {
  //   name: 'mainsidebar.label.corporateRequests',
  //   path: '/corporates/pending',
  //   icon: null,
  // },
  {
    name: 'mainsidebar.label.calculateEngine',
    path: '/calc-engine',
    rootPath: 'calc-engine',
    icon: null,
  },
  // {
  //   name: 'mainsidebar.label.inputTableEquation',
  //   path: '/input-table-equation',
  //   icon: null,
  // },
  // {
  //   name: 'mainsidebar.label.corpInvites',
  //   path: '/corporates/invites',
  //   icon: null,
  //   children: [
  //     {
  //       name: 'mainsidebar.label.sendInvite',
  //       path: '/send-invite',
  //       icon: null,
  //     },
  //     {
  //       name: 'mainsidebar.label.mangeCorpInvites',
  //       path: '/corporates/invites',
  //       icon: null,
  //     },
  //   ],
  // },
  {
    name: 'mainsidebar.label.corporates',
    path: '/corporates',
    icon: null,
    children: [
      {
        name: 'mainsidebar.label.manageCorpInvites',
        path: '/corporates/invites',
        icon: null,
        className: 'custom-nav-submenu-link',
      },
      {
        name: 'mainsidebar.label.pendingCorporates',
        path: '/corporates/pending',
        icon: null,
        className: 'custom-nav-submenu-link',
      },
      {
        name: 'mainsidebar.label.approvedCorporates',
        path: '/corporates/approved',
        icon: null,
        className: 'custom-nav-submenu-link',
      },
    ],
  },
  {
    name: 'mainsidebar.label.validators',
    path: '/validators',
    icon: null,
    children: [
      {
        name: 'mainsidebar.label.manageValidatorInvites',
        path: '/validators/invites',
        icon: null,
        className: 'custom-nav-submenu-link',
      },
    ],
  },
  // {
  //   name: 'mainsidebar.label.corporateStructure',
  //   path: '/corporates/approved',
  //   icon: null,
  // },
  {
    name: 'mainsidebar.label.dashboard',
    path: '/',
    icon: null,
  },
];

export const MAIN_SIDEBAR_EXECUTIVE = [];
export const MAIN_SIDEBAR_DATA_REPORTER = [];
export const MAIN_SIDEBAR_VALIDATOR = [
  {
    name: 'mainsidebar.label.validatorDashboard',
    path: '/',
    icon: null,
  },
  {
    name: 'mainsidebar.label.validationsReports',
    path: '/validators/reports',
    icon: null,
  },
];
